import { useSurveyLanguage } from '@/hooks/useSurveyLanguage';

export const PDPA_NOTICE_TITLE = 'NOTICE UNDER THE PERSONAL DATA PROTECTION ACT 2010 ("PDPA")';

function PdpaNoticeBodyEn() {
  return (
    <div className="mt-4 space-y-4 text-left font-normal leading-snug text-white/95">
      <p className="m-0 text-[12px] sm:text-[14px]">
        This written notice (&quot;Notice&quot;) serves to inform you that your personal data is being processed by
        or on behalf of Connect Dots (&quot;Connect Dots Sdn Bhd&quot; or &quot;we&quot; or &quot;us&quot;). As you
        are aware we will from time to time develop, organize and run programs such as trade-in, survey and
        research programs (&quot;Programs&quot;). Pursuant to the PDPA, you hereby consent to the processing of
        your personal data by Connect Dots in the manner as specified in this Notice. We shall be processing the
        personal data that you have provided us with such as your name, national registration identity card number,
        contact number and any other information that we have requested from you and will request from you from time
        to time. Connect Dots Sdn Bhd will be processing your personal data, including any additional information
        you may subsequently provide to us for the following purposes: -
      </p>
      <ul className="m-0 list-none space-y-2 pl-0 text-[12px] sm:text-[14px]">
        <li>(a) the invitation, dissemination, participation and implementation of the Programs; and</li>
        <li>(b) other purposes directly or indirectly relating to the Programs.</li>
      </ul>
      <p className="m-0 text-[12px] sm:text-[14px]">
        (hereinafter collectively referred to as the &quot;Purposes&quot;)
      </p>
      <p className="m-0 text-[12px] sm:text-[14px]">
        Your personal data may be disclosed to the public, our parent company, subsidiaries, associated company,
        licensees, business partners, distributors and/or service providers (including but limited to our legal advisors,
        auditors and banks) for any of the Purposes. You are responsible for ensuring that the personal data that
        you provide us is accurate, complete and not misleading and that such information is kept up to date. You may
        access and request for correction of your personal data, to limit the processing of your personal data, to
        withdraw your consent for us to process your personal data for any of the Purposes, or to contact us with any
        enquiries in respect of your personal data by contacting the Connect Dots Sdn Bhd Consumer Hotline:{' '}
        <a href="tel:01154345232" className="font-medium text-white underline underline-offset-2">
          011-5434 5232
        </a>
        . We may refuse to comply with your request or correction to your personal data under the PDPA and if we
        refuse to comply with such request, we will inform you of our refusal and the reason for our refusal. In the
        event you withdraw your consent, we may not be able to process your personal data for any of the Purposes.
        In the event of any inconsistency between the English and Bahasa Malaysia versions of this Notice, the
        English version shall prevail.
      </p>
    </div>
  );
}

function PdpaNoticeBodyBm() {
  return (
    <div className="mt-4 space-y-4 text-left font-normal leading-snug text-white/95">
      <p className="m-0 text-[12px] sm:text-[14px]">
        Notis bertulis ini (“Notis") bertujuan untuk memaklumkan kepada anda bahawa data peribadi anda akan diproses oleh atau bagi pihak Connect Dots Sdn Bhd ("Connect Dots Sdn Bhd " atau “kami"). Seperti yang dimaklum dari ke semasa kami akan mempertingkat, menyusun dan menyelenggara program-program termasuk kaji selidik dan “trade-in” ("Program") dan menjemput anda untuk menyertai Program tersebut. Selaras dengan PDPA anda bersetuju untuk membenarkan data peribadi diproses oleh Connect Dots Sdn Bhd sepertimana yang dinyatakan dalam Notis ini. Kami akan memproses data peribadi yang anda berikan kepada kami seperti nama, pengenalan, nombor telefon, dan sebarang butiran lain yang akan kami minta daripada anda dari masa ke semasa. Connect Dots akan memproses data peribadi anda, termasuklah sebarang maklumat tambahan yang anda mungkin berikan kemudian untuk tujuan seperti yang berikut:
      </p>
      <ul className="m-0 list-none space-y-2 pl-0 text-[12px] sm:text-[14px]">
        <li>(a) kaji selidik, pengumuman, penyertaan dan juga penambahbaikan Program; </li>
        <li>(b) sebarang tujuan lain yang berkaitan secara langsung atau tidak secara langsung dengan Program; dan </li>
        <li>(b) menjemput anda atau mencadangkan kepada anda pelbagai aktiviti pemasaran yang baharu. </li>
      </ul>
      <p className="m-0 text-[12px] sm:text-[14px]">
        (selepas ini dirujuk secara kolektif sebagai &quot;Tujuan-tujuan&quot;)
      </p>
      <p className="m-0 text-[12px] sm:text-[14px]">
        Maklumat peribadi anda mungkin akan dikongsi kepada syarikat induk kami, anak-anak syarikat, syarikat berkaitan dan/atau bersekutu, pemegang lesen, rakan kongsi perniagaan, pengedar dan/atau pembekal perkhidmatan (termasuk tetapi tidak terhad kepada penasihat undang-undang kami, juruaudit dan bank) untuk sebarang Tujuan-Tujuan yang dinyatakan di atas. Anda bertanggungjawab untuk memastikan bahawa maklumat yang anda berikan adalah tepat, lengkap dan tidak mengelirukan. Anda boleh mengakses dan memohon untuk memperbetulkan data peribadi anda, mengehadkan pemprosesan data peribadi anda, menarikbalik persetujuan anda kepada kami untuk memproses data peribadi anda untuk sebarang Tujuan-Tujuan yang dinyatakan di atas, atau menghubungi kami untuk apa-apa pertanyaan mengenai data peribadi anda dengan menghubungi talian konsumer Connect Dots Sdn Bhd di 011-54345232 Kami berhak untuk menolak permintaan anda untuk mengakses atau untuk membuat pembetulan ke atas data peribadi anda menurut PDPA dan sekiranya kami menolak permintaan tesebut. Kami akan memaklumkan sebab penolakan permintaan tersebut. Sekiranya anda menarikbalik persetujuan anda, kemungkinan kami tidak dapat memproses data peribadi untuk sebarang Tujuan-Tujuan seperti yang dinyatakan di atas. Sekiranya terdapat sebarang ketidakseragaman antara versi Bahasa Inggeris dan Bahasa Malaysia ke atas notis ini, maka versi Bahasa Inggeris akan digunakan. 
      </p>
    </div>
  );
}

function PdpaNoticeBodyCn() {
  return (
    <div className="mt-4 space-y-4 text-left font-normal leading-snug text-white/95">
      <p className="m-0 text-[12px] sm:text-[14px]">
        本书面通知（“通知”）旨在告知您：您的个人数据正由或代表 Connect Dots（“Connect Dots Sdn
        Bhd”或“我们”）进行处理。如您所知，我们会不时开发、组织并开展以旧换新、调查及研究等计划（“计划”）。根据
        PDPA，您特此同意 Connect Dots
        按本通知所述方式处理您的个人数据。我们将处理您向我们提供的个人数据，例如姓名、身份证号码、联系电话，以及我们已要求或日后可能要求您提供的其他信息。Connect
        Dots Sdn Bhd
        将为以下目的处理您的个人数据（包括您随后可能向我们提供的任何额外信息）：
      </p>
      <ul className="m-0 list-none space-y-2 pl-0 text-[12px] sm:text-[14px]">
        <li>（a）计划的邀请、发布、参与及实施；以及</li>
        <li>（b）与计划直接或间接相关的其他目的。</li>
      </ul>
      <p className="m-0 text-[12px] sm:text-[14px]">（以下统称为“目的”）</p>
      <p className="m-0 text-[12px] sm:text-[14px]">
        为上述任一目的，您的个人数据可能向公众、我们的母公司、子公司、关联公司、被许可方、业务伙伴、分销商和/或服务提供商（包括但不限于法律顾问、审计师及银行）披露。您有责任确保向我们提供的个人数据准确、完整、不具误导性，并保持更新。您可查阅并请求更正个人数据、限制处理、撤回对我们为任何目的处理个人数据的同意，或就个人数据相关事宜联系我们：Connect
        Dots Sdn Bhd 消费者热线{' '}
        <a href="tel:01154345232" className="font-medium text-white underline underline-offset-2">
          011-5434 5232
        </a>
        。根据
        PDPA，我们可能拒绝您的查阅或更正请求；若拒绝，我们将告知您拒绝决定及理由。若您撤回同意，我们可能无法再为任何目的处理您的个人数据。本通知英文与马来文版本如有不一致，以英文版本为准。
      </p>
    </div>
  );
}

export function PdpaNoticeBody() {
  const { surveyLanguage } = useSurveyLanguage();
  if (surveyLanguage === 'bm') return <PdpaNoticeBodyBm />;
  if (surveyLanguage === 'cn') return <PdpaNoticeBodyCn />;
  return <PdpaNoticeBodyEn />;
}
